var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "right-body", attrs: { id: "right-preview" } },
    [
      _c("div", { staticClass: "right-preview-middle" }, [
        _c("div", { staticClass: "preview-title" }, [
          _c("div", { staticClass: "preview-posiiton" }, [
            _c("div", { staticClass: "file-title-name" }, [
              _c("div", {
                staticClass: "icon-util come-back come-back-position",
                on: {
                  click: function($event) {
                    return _vm.goBackPage()
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "text-name",
                  attrs: { title: _vm.fileInfo.name }
                },
                [_vm._v(_vm._s(_vm.fileInfo.name))]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text-modified" }, [
              _vm._v(
                _vm._s(_vm.$t("language.cloudExploer.modified")) +
                  " " +
                  _vm._s(_vm._f("transferTime")(_vm.fileInfo.modifiedTime))
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "preview-icon" }, [
            _c("div", {
              staticClass: "icon-util big-copy-to preview-icon-position",
              attrs: { title: _vm.$t("language.common.copyTo") },
              on: {
                click: function($event) {
                  return _vm.copyToShow()
                }
              }
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "icon-util big-download preview-icon-position",
              attrs: { title: _vm.$t("language.common.download") },
              on: {
                click: function($event) {
                  return _vm.downLoad()
                }
              }
            }),
            _vm._v(" "),
            _vm.limits.write
              ? _c("div", {
                  staticClass: "icon-util big-delete preview-icon-position",
                  attrs: { title: _vm.$t("language.common.delete") },
                  on: {
                    click: function($event) {
                      return _vm.deleteFile()
                    }
                  }
                })
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        false
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "clickoutside",
                    rawName: "v-clickoutside",
                    value: _vm.onlineClose,
                    expression: "onlineClose"
                  }
                ],
                staticClass: "open-with",
                on: {
                  click: function($event) {
                    _vm.onlineShow = !_vm.onlineShow
                  }
                }
              },
              [
                _c("div", { staticClass: "open-width-txt" }, [
                  _vm._v(_vm._s(_vm.$t("language.cloudExploer.openWith")))
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "icon-util  open-width-position",
                  class: _vm.onlineShow ? "drop-down-up" : "drop-down"
                }),
                _vm._v(" "),
                _vm.onlineShow
                  ? _c(
                      "div",
                      {
                        staticClass: "office-online",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.officeOnlineOpen()
                          }
                        }
                      },
                      [
                        _c("div", {
                          staticClass:
                            "icon-util office-online-icon office-online-icon-position"
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "office-online-txt" }, [
                          _vm._v(
                            _vm._s(_vm.$t("language.cloudExploer.officeOnline"))
                          )
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "right-preview-body",
          on: {
            wheel: function($event) {
              return _vm.rollImg()
            }
          }
        },
        [
          _vm.loadFlag
            ? _c("div", { staticClass: "preview-loading" }, [
                _vm._v(_vm._s(_vm.$t("language.cloudExploer.loading")))
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.googleDriveArr.includes(_vm.fileType)
            ? _c("iframe", {
                ref: "googleDriveView",
                staticClass: "iframe-position",
                class: _vm.fileType == "txt" ? "iframe-txt-width" : "",
                attrs: {
                  height: "96%",
                  seamless: "seamless",
                  frameborder: "no",
                  scrolling: "auto",
                  src: _vm.fileUrl
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.officeArr.includes(_vm.fileType)
            ? _c("iframe", {
                staticClass: "iframe-position",
                attrs: {
                  height: "96%",
                  width: "98%",
                  seamless: "seamless",
                  frameborder: "no",
                  scrolling: "auto",
                  src: _vm.fileUrl
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.imgArr.includes(_vm.fileType)
            ? _c("img", {
                ref: "bigImage",
                staticStyle: { transform: "matrix(1, 0, 0, 1, 0, 0)" },
                attrs: { src: _vm.fileUrl }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.imgArr.includes(_vm.fileType)
            ? _c("div", { staticClass: "img-zoom" }, [
                _c("div", {
                  staticClass: "icon-util zoom-down preview-icon-posiiton",
                  on: {
                    click: function($event) {
                      return _vm.zoomDown()
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "icon-util zoom-recover preview-icon-posiiton",
                  on: {
                    click: function($event) {
                      return _vm.zoomRecover()
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "icon-util zoom-up preview-icon-posiiton",
                  on: {
                    click: function($event) {
                      return _vm.zoomUp()
                    }
                  }
                })
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.otherType
            ? _c("div", { staticClass: "other-type" }, [
                _c("div", { staticClass: "other-img" }),
                _vm._v(" "),
                _c("div", [
                  _c("span", { staticClass: "suffix-type" }, [
                    _vm._v("." + _vm._s(_vm.fileType))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "not-review" }, [
                    _vm._v(_vm._s(_vm.$t("language.preview.fileNotReview")))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "exe-info" }, [
                  _c("span", { attrs: { title: _vm.fileInfo.name } }, [
                    _vm._v(
                      _vm._s(_vm._f("ellipsisNavi")(_vm.fileInfo.name)) +
                        " - " +
                        _vm._s(_vm._f("formatByte")(_vm.fileInfo.size))
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm.toOfficialSiteshow()
                    ? _c(
                        "button",
                        {
                          staticClass: "exe-button",
                          on: {
                            click: function($event) {
                              return _vm.goOfficialSite()
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("language.preview.goOringinalSite"))
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c("shareDialog", { ref: "shareDialog" }),
      _vm._v(" "),
      _c("copyToDialog", { ref: "copyToDialog" }),
      _vm._v(" "),
      _c("fileExistDialog", { ref: "fileExistDialog" }),
      _vm._v(" "),
      _c("detailedProgrssDialog", { ref: "detailedProgrss" }),
      _vm._v(" "),
      _c("remindBindEmailDialog", { ref: "remindBindEmailDialog" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ccdcdd24", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ccdcdd24","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workspace/preview.vue
// module id = null
// module chunks = 